import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import StudioReportPage from "~/components/studio/StudioReportPage"
import NotFound from "~/components/reusable/NotFound"

import { usePageTracking } from "../../../hooks/usePageTracking"

const searchSchema = z.object({
  run: z.number().int().optional(),
})

export const Route = createFileRoute("/_auth/insights/studio/$reportId")({
  component: RouteComponent,
  validateSearch: searchSchema,
})

function RouteComponent() {
  const { reportId } = Route.useParams()
  const { run } = Route.useSearch()
  usePageTracking("Studio Report")

  const reportIdNum = Number(reportId)
  if (!Number.isFinite(reportIdNum)) return <NotFound />

  return <StudioReportPage reportId={reportIdNum} runOnMount={run === 1} />
}
